module.exports = __webpack_public_path__ + "static/media/SimplonMono.942da703.woff";